export default __webpack_public_path__ + "static/media/primordial_jade_winged_spear.ea10bc42.png";